import React, { useState } from "react";
import api from "../services/api";
import StatementDownloadForm from "../components/StatementDownloadForm";

function FinancialDocuments() {
  const [type, setType] = useState("customer");
  const [query, setQuery] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [searching, setSearching] = useState(false);

  const handleSearch = async () => {
    if (!query.trim()) return;
    setSearching(true);
    setError("");
    setResult(null);

    try {
      const endpoint = type === "customer" ? "/searchusersbynameornum" : "/searchdriverbynameornum"; // adjust to your actual search endpoints
      const res = await api.get(endpoint, { params: { query: query.trim() } });
      const found = type === "customer" ? res.data.users?.[0] : res.data.drivers?.[0];

      if (!found) {
        setError(`No ${type} found matching "${query}"`);
      } else {
        setResult(found);
      }
    } catch (err) {
      setError("Search failed");
    } finally {
      setSearching(false);
    }
  };

  return (
    <div style={styles.page}>
      <h1 style={styles.title}>Financial Documents</h1>

      <div style={styles.tabs}>
        <button
          style={{ ...styles.tabBtn, ...(type === "customer" ? styles.tabActive : {}) }}
          onClick={() => { setType("customer"); setResult(null); setQuery(""); }}
        >
          👤 Customer Statement
        </button>
        <button
          style={{ ...styles.tabBtn, ...(type === "driver" ? styles.tabActive : {}) }}
          onClick={() => { setType("driver"); setResult(null); setQuery(""); }}
        >
          🚚 Driver Earnings Statement
        </button>
      </div>

      <div style={styles.searchRow}>
        <input
          style={styles.input}
          placeholder={`Search ${type} by name or phone...`}
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleSearch()}
        />
        <button style={styles.searchBtn} onClick={handleSearch} disabled={searching}>
          {searching ? "Searching..." : "Search"}
        </button>
      </div>

      {error && <div style={styles.errorBanner}>{error}</div>}

      {result && (
        <div style={styles.resultCard}>
          <div style={styles.resultName}>{result.name} — {result.phone}</div>
          <StatementDownloadForm
            baseUrl={type === "customer" ? "/documents/customer-statement" : "/documents/driver-earnings"}
            id={result._id}
            filenamePrefix={type === "customer" ? "statement" : "earnings"}
          />
        </div>
      )}
    </div>
  );
}

const styles = {
  page: { padding: "30px", background: "#f1f5f9", minHeight: "100vh", fontFamily: "'Inter', sans-serif" },
  title: { margin: "0 0 20px 0", fontSize: "26px", fontWeight: "800", color: "#0f172a" },
  tabs: { display: "flex", gap: "8px", marginBottom: "16px" },
  tabBtn: {
    padding: "10px 18px", borderRadius: "10px", border: "1px solid #e2e8f0",
    background: "#fff", cursor: "pointer", fontWeight: "700", fontSize: "13px", color: "#475569",
  },
  tabActive: { background: "#6366f1", color: "#fff", border: "1px solid #6366f1" },
  searchRow: { display: "flex", gap: "10px", marginBottom: "16px" },
  input: { flex: 1, padding: "12px 14px", borderRadius: "10px", border: "1px solid #e2e8f0", fontSize: "14px" },
  searchBtn: {
    background: "#6366f1", color: "#fff", border: "none", padding: "0 24px",
    borderRadius: "10px", fontWeight: "700", cursor: "pointer",
  },
  errorBanner: { background: "#fee2e2", color: "#991b1b", padding: "12px 16px", borderRadius: "10px", fontSize: "13px", fontWeight: "600" },
  resultCard: { background: "#fff", borderRadius: "16px", padding: "20px", boxShadow: "0 4px 6px -1px rgba(0,0,0,0.05)" },
  resultName: { fontSize: "16px", fontWeight: "800", color: "#0f172a", marginBottom: "14px" },
};

export default FinancialDocuments;